/* eslint-disable react-hooks/exhaustive-deps */
import { useNavigate } from "react-router-dom"
import { Box, Button, Stack, Typography } from "@mui/material"
import { PersonAdd } from "@mui/icons-material"
import { CheckUserAllowedComponent } from "../app/components/check-user-allowed-component"
import UsersListTable from "../features/users-list/components/users-list-table"
import UserFormDialog from "../features/users-list/components/user-form-dialog"
import { useAppDispatch } from "../app/hooks"
import { openCreateUserDialogAct } from "../features/users-list/user-list.slice"
import Title from "../features/dashboard/components/Title"

export default function UsersListView() {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()

  const notAllowed = (allowed: boolean) => {
    if (!allowed) {
      navigate("/dashboard")
    }
  }

  return (
    <CheckUserAllowedComponent checkIfAdmin={true} onCheckPermission={notAllowed}>
      <Stack spacing={2}>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            alignItems: { xs: "stretch", sm: "center" },
            justifyContent: "space-between",
            gap: 2,
          }}
        >
          <Box>
            <Title>Usuarios</Title>
            <Typography variant="body2" color="text.secondary">
              Administra cuentas, roles y códigos de referido.
            </Typography>
          </Box>
          <Button
            variant="contained"
            startIcon={<PersonAdd />}
            onClick={() => dispatch(openCreateUserDialogAct())}
            sx={{ alignSelf: { xs: "stretch", sm: "auto" }, cursor: "pointer" }}
          >
            Nuevo usuario
          </Button>
        </Box>
        <UsersListTable />
        <UserFormDialog />
      </Stack>
    </CheckUserAllowedComponent>
  )
}
